import { type StateType } from '../../states';
import { type SearchState } from '../../states/search';
import { type CategoryId } from '../../types/categories';
import { type Selector } from '../../types/selectors';

const emptyArr: [] = [];
const emptyCategoryArr: Array<CategoryId> = [];

const selectSearchState: Selector<SearchState | undefined> = (state: StateType) => state.search;

export const selectSearchIsLoading: Selector<boolean> = (state: StateType) =>
  selectSearchState(state)?.isLoading ?? false;

export const selectSearchQuery: Selector<string> = (state: StateType) => selectSearchState(state)?.query ?? '';

export const selectSearchMatchIds: Selector<Array<number>> = (state: StateType) =>
  selectSearchState(state)?.matchIds ?? emptyArr;

export const selectSearchSuggestion: Selector<string> = (state: StateType) =>
  selectSearchState(state)?.suggestion ?? '';

export const selectSearchCategories: Selector<Array<CategoryId>> = (state: StateType) =>
  selectSearchState(state)?.categories ?? emptyCategoryArr;

export const selectSearchTournaments: Selector<Array<number>> = (state: StateType) =>
  selectSearchState(state)?.tournaments ?? emptyArr;

export const selectSearchBets: Selector<Array<number>> = (state: StateType) =>
  selectSearchState(state)?.bets ?? emptyArr;

export const selectSearchOutcomes: Selector<Array<number>> = (state: StateType) =>
  selectSearchState(state)?.outcomes ?? emptyArr;
